export const practiceApiUrl = (platformDomain: string): string => {
  const scheme = new URL(import.meta.env.REACT_APP_API_BASE_URL ?? globalThis.location.href)
    .protocol;
  return `${scheme}//${platformDomain}`;
};
